<div appInViewPort (visible)="isVisible($event)"
  class="hero-light relative pt-24 pb-14 lg:pt-28 lg:pb-20 overflow-hidden">

  <div class="hero-wash pointer-events-none absolute inset-0 -z-0"></div>

  <div class="reusable-container relative z-10 grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
    <!-- Copy -->
    <div class="flex flex-col gap-6 text-center lg:text-left">
      <h1 class="hero-headline max-w-xl">
        Where <span class="hero-headline-accent font-playfair italic">Tanzania</span>
        meets, decides, and moves forward.
      </h1>

      <p class="hero-subhead max-w-xl mx-auto lg:mx-0">
        One secure platform for scheduling, hosting, recording, and reporting
        on every meeting across government, agencies, and institutions.
      </p>

      <div class="flex flex-wrap justify-center lg:justify-start gap-3 mt-2">
        <button (click)="goTo('/auth/register')" appRipple class="hero-cta-primary">
          Start a meeting
          <mat-icon class="!text-base !h-4 !w-4 ml-1">arrow_forward</mat-icon>
        </button>
        <button (click)="goTo('/auth/join-meeting')" appRipple class="hero-cta-ghost">
          Join with code
        </button>
      </div>

      <div class="hero-stats mt-6">
        <div class="stat">
          <div class="stat-num">20+</div>
          <div class="stat-lbl">Public institutions</div>
        </div>
        <div class="stat">
          <div class="stat-num">10k+</div>
          <div class="stat-lbl">Meetings hosted</div>
        </div>
        <div class="stat">
          <div class="stat-num">99.9%</div>
          <div class="stat-lbl">Uptime SLA</div>
        </div>
      </div>
    </div>

    <!-- Visual -->
    <div class="hero-visual">
      <div class="hero-visual-glow"></div>
      <div class="hero-grid-bg"></div>

      <div class="hero-frame">
        <div class="hero-frame-topbar">
          <span class="dot red"></span>
          <span class="dot yellow"></span>
          <span class="dot green"></span>
          <div class="hero-frame-url">
            <mat-icon class="!text-sm !h-3.5 !w-3.5">lock</mat-icon>
            app.e-mikutano.go.tz
          </div>
        </div>
        <img src="assets/images/artboard3.png" alt="e-Mikutano platform" class="hero-visual-img" />
      </div>

      <div class="hero-chip hero-chip-tl">
        <span class="live-dot"></span>
        HD meeting live
      </div>
      <div class="hero-chip hero-chip-br">
        <mat-icon class="!text-base !h-4 !w-4">shield</mat-icon>
        Encrypted end-to-end
      </div>

      <div class="hero-peek">
        <div class="hero-peek-head">
          <div class="hero-peek-avatars">
            <span class="av av1">AM</span>
            <span class="av av2">JL</span>
            <span class="av av3">PK</span>
            <span class="av av-more">+8</span>
          </div>
          <span class="hero-peek-count">11 attending</span>
        </div>
        <div class="hero-peek-title">Cabinet session — Q4 review</div>
        <div class="hero-peek-meta">
          <mat-icon class="!text-sm !h-3.5 !w-3.5">schedule</mat-icon>
          Starts in 12 min
        </div>
      </div>
    </div>
  </div>
</div>
